export default "__VITE_ASSET__DfQp0Jv9__"